export default __webpack_public_path__ + "static/media/heritage.919a7727.svg";